import React from "react";
import { getFullUrl } from "lib/utils/urls";


export default function Link(props) {
  const { className, text, external, url } = props;
  const fullUrl = getFullUrl(url, external);
  return (
    <a
      data-testid="t-Link-a"
      className={className}
      href={fullUrl.href}
      target={external ? "_blank" : null}>
      {text}
    </a>
  );
}
